import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore, Timestamp } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAbmxdPDH7pjEhzQlQRCb4Y2N9_tUxPayA",
    authDomain: "matthewscoresby-f7ce8.firebaseapp.com",
    databaseURL: "https://matthewscoresby-f7ce8-default-rtdb.firebaseio.com",
    projectId: "matthewscoresby-f7ce8",
    storageBucket: "matthewscoresby-f7ce8.appspot.com",
    messagingSenderId: "1072237585737",
    appId: "1:1072237585737:web:6c2f31e0481c139a62e698"
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Authentication instance
const auth = getAuth(app);

// Set persistence to browserLocalPersistence
setPersistence(auth, browserLocalPersistence)
    .then(() => {
        console.log("Persistence set to browserLocalPersistence.");
        // Persistence setting applied; authentication methods can be used here.
    })
    .catch((error) => {
        console.error("Error setting persistence:", error);
    });

// Database
const db = getFirestore(app);

// Export initialized Firebase app and authentication instance
export { app, auth, db, Timestamp };